const Debug = () => {
  return <div>debug</div>;
};

export { Debug };
